<template>
  <div>
    <van-tabbar
      v-model="active"
      active-color="#0086F8"
      inactive-color="#999999"
      class="tabBarBox"
    >
      <van-tabbar-item name="Robot" :icon="active === 'Robot'
          ? require('@/assets/images/user-active.svg')
          : require('@/assets/images/user.svg')
        " to="/robot" :style="{ paddingRight: '20px' }">
        <span>{{ $t('我的') }}</span>
      </van-tabbar-item>
      <!-- <van-tabbar-item
        name="Meeting"
        :icon="
          active === 'Meeting'
            ? require('@/assets/images/meeting-active.png')
            : require('@/assets/images/meeting.png')
        "
        to="/meeting"
      >
        <span>会议预约</span>
      </van-tabbar-item> -->
      <van-tabbar-item name="User" :icon="active === 'User'
          ? require('@/assets/images/setting-active.svg')
          : require('@/assets/images/setting.svg')
        " to="/user" :style="{ paddingLeft: '20px' }">
        <span>{{ $t('设置') }}</span>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import Vue from 'vue'
import { Tabbar, TabbarItem } from 'vant'
Vue.use(Tabbar)
Vue.use(TabbarItem)
export default {
  name: 'TabBar',
  props: ['narBarTitle', 'msg'],
  data() {
    return {
      active: '',
    }
  },
  methods: {},
  mounted() {
    this.active = this.$route.name
  },
}
</script>
<style lang="less" scoped>
.tabBarBox {
  height: 68px;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);

  span {
    display: block;
    // margin-top: 3px;
    line-height: 18px;
    font-family: SourceHanSansSC, SourceHanSansSC;
    font-weight: 400;
    font-size: 12px;
  }
}

/deep/.van-icon__image {
  width: 24px;
  height: 24px;
}

/deep/.van-tabbar-item__text {
  span {
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    font-family: SourceHanSansSC, SourceHanSansSC;
  }
}
</style>
